module.exports = __webpack_public_path__ + "static/logo-c0d4432f5377eb6b02a44b4a3fb0b4e0.png";